import { Component, Input, OnInit } from '@angular/core';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { IconButtonVM } from '../../factories/button.factory';
import { LocLabel } from '../clickable-row-table/models/data-table-config.models';

@Component({
  selector: 'app-form-section-category',
  templateUrl: './form-section-category.component.html',
  styleUrls: ['./form-section-category.component.scss']
})
export class FormSectionCategoryComponent implements OnInit {
  /** @deprecated use headerKey */
  @Input() header?: string;
  @Input() headerKey?: LocLabel | string | null = null;
  @Input() minor?: boolean;

  @Input() headerButtons: IconButtonVM[] = [];

  constructor(public rwdService: RWDService) {}

  ngOnInit(): void {}
}
